"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
var _exportNames = {
  ConfiguratorSecondaryNavigation: true
};
exports.ConfiguratorSecondaryNavigation = void 0;
var _configuratorSecondaryNavigation = _interopRequireDefault(require("./components/configurator-secondary-navigation"));
exports.ConfiguratorSecondaryNavigation = _configuratorSecondaryNavigation["default"];
var _configuratorSecondaryNavigation2 = require("./components/configurator-secondary-navigation.props/configurator-secondary-navigation.propTypes");
Object.keys(_configuratorSecondaryNavigation2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _configuratorSecondaryNavigation2[key]) return;
  exports[key] = _configuratorSecondaryNavigation2[key];
});